import './App.css';
import { useEffect, useRef } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import { analytics } from './lib/analytics';
import Question from './pages/Question';
import Results from './pages/Results';

function App({ mode }) {
    const location = useLocation();
    useEffect(() => {
        analytics('nhs-healthcheck', { page: location.pathname });
    }, [location]);

    const AboutQuestions = [
        {
            question: "Are you aged 40 - 74?",
            fieldKey: "age",
            answer: 'yes',
        },
        {
            question: "Are you living in Dorset or registered with a GP in Dorset?",
            fieldKey: "gp",
            answer: 'yes',
        },
        {
            question: "Have you had an NHS Health Check in the last 5 years?",
            fieldKey: "healthcheck",
        },
    ];

    const HealthQuestions = [
        {
            question: "Are you currently being prescribed medication to manage your cholesterol?",
            fieldKey: "statins",
        },
        {
            question: "Have you been diagnosed with coronary heart disease?",
            fieldKey: "coronary",
            hint: "Coronary heart disease is the term that describes what happens when your heart's blood supply is blocked or interrupted by a build-up of fatty substances in the coronary arteries",
        },
        {
            question: "Have you been diagnosed with chronic kidney disease (CKD), which has been classified as stage 3,4 or 5?",
            fieldKey: "kidney",
            hint: "Chronic kidney disease (CKD) is a long-term condition where the kidneys don't work as well as they should."
        },
        {
            question: "Have you been diagnosed with diabetes?",
            fieldKey: "diabetes",
            hint: "Diabetes is a lifelong condition that causes a person's blood sugar level to become too high."
        },
        {
            question: "Have you been diagnosed with hypertension (high blood pressure)?",
            fieldKey: "hypertension",
            hint: "Hypertension, also known as high or raised blood pressure, is a condition in which the blood vessels have persistently raised pressure"
        },
        {
            question: "Have you been diagnosed with atrial fibrillation?",
            fieldKey: "atrial",
            hint: "Atrial fibrillation is a heart condition that causes an irregular and often abnormally fast heart rate"
        },
        {
            question: "Have you been diagnosed with transient ischaemic attack (TIA)?",
            fieldKey: "tia",
            hint: 'A transient ischaemic attack (TIA) or "mini stroke" is caused by a temporary disruption in the blood supply to part of the brain.'
        },
        {
            question: "Have you been diagnosed with Inherited high cholesterol – defined as familial hypercholesterolemia?",
            fieldKey: "cholesterol",
            hint: "Familial hypercholesterolaemia (FH) is a genetic condition that causes high cholesterol and coronary heart disease, often resulting in premature heart disease"
        },
        {
            question: "Have you been diagnosed with heart failure?",
            fieldKey: "heartfailure",
            hint: "Heart failure means that the heart is unable to pump blood around the body properly. It usually occurs because the heart has become too weak or stiff."
        },
        {
            question: "Have you been diagnosed with peripheral arterial disease (PAD)?",
            fieldKey: "pad",
            hint: "Peripheral arterial disease (PAD) is a common condition where a build-up of fatty deposits in the arteries restricts blood supply to leg muscles."
        },
        {
            question: "Have you ever suffered from a stroke?",
            fieldKey: "stroke",
            hint: "A stroke is a serious life-threatening medical condition that happens when the blood supply to part of the brain is cut off?"
        },
        {
            question: "Have you been identified as having a 20% (or higher) risk of developing cardiovascular disease over the next 10 years",
            fieldKey: "cvd",
        },
    ];
    
    const qw = [
        "All of our venues are fully disabled accessible.",
        "However, we understand that some of our participants may require reasonable adjustments to attend their health check, such as additional time or help from a carer or support worker, during their health check.",
        "Please contact us on 01305 233105 or email healthchecks@livewelldorset.co.uk if you would like us to make any reasonable adjustments to facilitate your health check.",
        "Please also note that our NHS Health Checks are carried out in a variety of community venues - including libraries, sports clubs and community centres. This means that other activities may be taking place at many of our venues.",
        "Also in some cases our practitioners will be lone working on site. If you have any queries about our venues please contact us before booking, so we can help find you an appointment at a venue that meets your needs. Please select 'yes' to confirm that you have read this statement?"
    ].join("\n");
    const DetailsQuestions = [
        {
            question: qw,
            fieldKey: "accessibility",
        },
    ];


    const routes = (<Routes>
        <Route path="/" exact element={<Question title="About You" questions={AboutQuestions} next="/your-health" key={1} showHeading />} />
        <Route path="/your-health" exact element={<Question title="Your Health" questions={HealthQuestions} next="/results" key={2} />} />
        {/* <Route path="/your-details" exact element={<Question title="Accessibility and Adjustments" questions={DetailsQuestions} next="/results" />} /> */}
        <Route path="/results" exact element={<Results />} />

    </Routes>);


    return routes;
}

export default App;
